export default __webpack_public_path__ + "61e6e5f4295dcfa06eea6e125aefc349.jpeg";